import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('befit-chat-header')
export class ChatHeader extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 18px;
      background: var(--befit-primary, #101828);
      color: white;
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
      border-bottom: 2px solid var(--befit-accent, #8FFE09);
    }
    .title {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    .name {
      font-weight: 700;
      font-size: 15px;
      letter-spacing: 0.02em;
    }
    .name::after {
      content: ".";
      color: var(--befit-accent, #8FFE09);
    }
    .status {
      font-size: 12px;
      color: var(--befit-muted, #98A2B3);
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .status::before {
      content: "";
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: var(--befit-accent, #8FFE09);
      box-shadow: 0 0 8px var(--befit-accent, #8FFE09);
    }
    .actions {
      display: flex;
      gap: 4px;
    }
    .icon-btn {
      background: transparent;
      color: white;
      border: none;
      cursor: pointer;
      padding: 6px;
      line-height: 0;
      opacity: 0.7;
      border-radius: 6px;
      transition: opacity 0.15s ease, background 0.15s ease;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .icon-btn:hover {
      opacity: 1;
      background: rgba(255,255,255,0.08);
    }
    .icon-btn svg {
      width: 16px;
      height: 16px;
    }
    .icon-btn.close svg {
      width: 18px;
      height: 18px;
    }
  `;

  @property({ type: String }) override title = 'BEFIT';
  @property({ type: String }) subtitle = 'Asistent virtual AI';

  private close() {
    this.dispatchEvent(new CustomEvent('close', { bubbles: true, composed: true }));
  }

  private reset() {
    this.dispatchEvent(new CustomEvent('reset', { bubbles: true, composed: true }));
  }

  override render() {
    return html`
      <div class="title">
        <span class="name">${this.title}</span>
        <span class="status">${this.subtitle}</span>
      </div>
      <div class="actions">
        <button class="icon-btn" @click=${this.reset} aria-label="Resetează conversația" title="Resetează conversația">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="1 4 1 10 7 10"></polyline>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
        </button>
        <button class="icon-btn close" @click=${this.close} aria-label="Minimizează" title="Minimizează">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'befit-chat-header': ChatHeader;
  }
}
